import {DistributionsService} from "../../../../service/distributionList.service";
import {ViewDistributionList} from "../../../common/distribution/viewDistributionList";


export default function ViewDistributionListArauco() {
    const onUpdateDistributionList = async (id: string) => {
        window.open(`/arauco/distribution/${id}`, '_blank');
    };
    const onGetDistributionLists = async () => {
        return await DistributionsService.findAll("arauco");
    };
    const onDeleteDistributionList = async (id: string) => {
        return await DistributionsService.remove(id);
    };

    return(<ViewDistributionList onGetLists={onGetDistributionLists} onUpdate={onUpdateDistributionList} onDelete={onDeleteDistributionList}/>)
}